"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CfgCurrencyListEn_1 = require("./CfgCurrencyListEn");
var CfgCurrencyListRu_1 = require("./CfgCurrencyListRu");
var CfgCurrencyListLangFactory = /** @class */ (function () {
    function CfgCurrencyListLangFactory() {
    }
    CfgCurrencyListLangFactory.getLangInstance = function (Lang) {
        if (Lang == "RU") {
            return CfgCurrencyListRu_1.CfgCurrencyListRu.getLangData();
        }
        return CfgCurrencyListEn_1.CfgCurrencyListEn.getLangData();
    };
    return CfgCurrencyListLangFactory;
}());
exports.CfgCurrencyListLangFactory = CfgCurrencyListLangFactory;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_currency/ui/lang/CfgCurrencyListBase.ts
// module id = 2041
// module chunks = 0